import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    userId: null,
    dealerId: null,
    sapDealerId: null,
    usageType: null,
    addrId: null,
    sapAddrId: null,
    siteUseId: null,
    dealerFullName: null,
    customerDealer: null,
    customerErpAddressId: null,
    isContractedShipAddr: false,
    isKmobilityUser: false,
    languageId: null,
    userEmail: null,
    // Onay Bekleyen Siparişler erişim kontrolü için
    isSubDealer: false,
    isInterservice: false,
    // Bayi Parça İade Süreci için (yurt içi/yurt dışı kontrolü)
    isDomestic: false,
    isCanUseFullServiceDealer:false
};

const userParamsSlice = createSlice({
    name: 'userParams',
    initialState,
    reducers: {
        setUserParams: (state, action) => {
            return { ...state, ...action.payload };
        },
        setSiteUseId: (state, action) => {
            state.siteUseId = action.payload;
        },
        clearUserParams: () => initialState
    }
});

export const { setUserParams, setSiteUseId, clearUserParams } = userParamsSlice.actions;

// Selectors
export const selectUserParams = (state) => state.userParams;
export const selectSiteUseId = (state) => state.userParams.siteUseId;
export const selectDealerId = (state) => state.userParams.dealerId;
export const selectLanguageId = (state) => state.userParams.languageId;
export const selectUserEmail = (state) => state.userParams.userEmail;

export default userParamsSlice.reducer;
